import React from "react";
import { IconBase, type IconProps } from "./IconBase";
import checkmarkSVG from "images/icons/checkmark.svg";

export const CheckmarkIcon = (props: IconProps) => {
  return <IconBase {...props} href={checkmarkSVG} />;
};
